import { render } from "./AuthFailure.vue?vue&type=template&id=f39043a2&scoped=true"
import script from "./AuthFailure.vue?vue&type=script&lang=js"
export * from "./AuthFailure.vue?vue&type=script&lang=js"

import "./AuthFailure.vue?vue&type=style&index=0&id=f39043a2&scoped=true&lang=css"

import exportComponent from "/builds/p3839/client-suite/proxima_blue2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f39043a2"]])

export default __exports__